module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "475px",
      "src": "images/f0006-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('h2', {
    staticClass: "h2r"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")]), _c('br'), _vm._v("Make Room for Fantastically Full")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("CHAPTER 1")]), _c('br'), _vm._v("Your Complete Prep Guide to Wicked Good Meals")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_c('strong', [_vm._v("CHAPTER 2")]), _c('br'), _vm._v("Down-Home Breakfasts")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 3")]), _c('br'), _vm._v("Mean and Mouthwatering Mains")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 4")]), _c('br'), _vm._v("Over-the-Top, Totally Tantalizing Sides")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 5")]), _c('br'), _vm._v("The Bottomless Bread Basket")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 6")]), _c('br'), _vm._v("Condiments, Sauces, and Other Staples")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHAPTER 7")]), _c('br'), _vm._v("Ooey, Gooey, and Downright Sinful Sweets")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "cont2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "475px",
      "src": "images/f0008-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee67910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 66
// module chunks = 0